






















import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import HistoryEntry from '../models/HistoryEntry'
import moment from 'moment'

@Component
export default class HisotryTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  private loading!: boolean

  @Prop({ default: () => [] })
  private history!: HistoryEntry[]

  formatDate(date: string, format: string) {
    return moment(date).format(format)
  }

  private get headers() {
    return [
      {
        text: this.$t('history.components.history-table.header.title'),
        value: 'title',
        sortable: false,
      },
      {
        text: this.$t('history.components.history-table.header.message'),
        value: 'message',
        sortable: false,
      }
    ]
  }
}
